import { render, staticRenderFns } from "./TabCreazioneNota.vue?vue&type=template&id=2bb211f9&"
import script from "./TabCreazioneNota.vue?vue&type=script&lang=js&"
export * from "./TabCreazioneNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabCreazioneNota.vue
// module id = 720
// module chunks = 0